import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import Header from './components/Header';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ProfilePage from './pages/ProfilePage';
import EditProfilePage from './pages/EditProfilePage';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import AdminDashboard from './pages/AdminDashboard';
import DetailPage from "./pages/Detail";
import ForbiddenPage from './pages/ForbiddenPage';
import FavoritesPage from "./pages/FavoritesPage";
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyAccountPage from './pages/VerifyAccountPage';
import SavedSearchesPage from './pages/SavedSearchesPage';
import { APIBaseLink } from './components/APIBaseLink';


function App() {
  return (
    //for Google translation of website
    // <GoogleTranslateProvider pageLanguage="en"> 
      <AuthProvider>
        <Router>
          <main>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/edit-profile" element={<EditProfilePage />} />
            <Route path="/search-results" element={<SearchResultsPage />} />
            <Route path="/detail/:id" element={<DetailPage />} />
            <Route path="/forbidden" element={<ForbiddenPage />} />
            <Route path="/admin/*" element={<AdminRoute component={AdminDashboard} />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/saved-searches" element={<SavedSearchesPage />} />
            <Route path="/resetPassword/:token" element={<ResetPasswordPage />} />
            <Route path="/verifyAccount/:token" element={<VerifyAccountPage />} />
          </Routes>
          </main>
        </Router>
      </AuthProvider>
    // </GoogleTranslateProvider>
  );
}

// Function that checks if user is admin and redirects them if not
function AdminRoute({ component: Component }) {
  const { user } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const [hasAdminAccess, setHasAdminAccess] = useState(false); // Denies Access by Default
  const API_BASE_LINK = APIBaseLink();

  useEffect(() => { 
    const fetchUserRole = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_BASE_LINK}/user/check-role`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Pass the token securely
          },
        });

        if (response.ok) {
          const data = await response.json();
          setHasAdminAccess(data.role === 'admin'); // Check if the role is 'admin'
        } else {
          console.error('Failed to verify user role');
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserRole();
  }, [user]);

  if (isLoading) {
    return <div>Loading...</div>; // Display a loading state while verifying the role
  }

  if (!hasAdminAccess) {
    return <Navigate to="/forbidden" />; // Redirect if the user is not an admin
  }

  return <Component />;
}

export default App;
